// Records which i18n namespaces a rendered page actually uses.
//
// During SSR, every useTranslation() call resolves its t() through the
// i18n.getFixedT() wrapper in src/i18n.js, which records the namespace here.
// gatsby-ssr.js resets the list before each page render and stamps the result
// into the HTML (<html data-i18n-ns="...">). The browser then awaits exactly
// those namespaces before hydrating — see src/i18n.js.
//
// State lives on the Node `global` object because gatsby-ssr.js and the rendered page tree
// are separate webpack compilations and must observe the same list. Tracking
// is a no-op in the browser. (ES2020's globalThis is unknown to the dev
// linter's env, and this path only ever runs under Node.)

const GLOBAL_KEY = "__P2C_I18N_NS__";

const isSSR = () => typeof window === "undefined";

const getStore = () => {
  if (!isSSR()) return null;
  if (!global[GLOBAL_KEY]) global[GLOBAL_KEY] = new Set();
  return global[GLOBAL_KEY];
};

export const trackNamespace = (ns) => {
  const store = getStore();
  if (!store || ns == null) return;
  (Array.isArray(ns) ? ns : [ns]).forEach((name) => {
    if (typeof name === "string" && name) store.add(name);
  });
};

export const resetTrackedNamespaces = () => {
  getStore()?.clear();
};

export const getTrackedNamespaces = () => {
  const store = getStore();
  return store ? Array.from(store) : [];
};
